var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',[_c('div',{staticClass:"d-block",class:[_vm.$vuetify.breakpoint.mdAndUp && 'fill-height']},[_c('page-app-bar'),_c('router-view',{key:_vm.$route.path}),_c('page-footer')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }